<div class="bilag-liste">
  @for (formGroup of formArray.controls; track formGroup) {
    <note-bilag [formGroup]="formGroup"></note-bilag>
  }
</div>

<div class="button-panel">
  <image-upload-button (add)="onTilfoejBillede($event)"></image-upload-button>
</div>
